import { createSlice } from '@reduxjs/toolkit';

const initialState = {
  currentLevel: 1, // Which level the athlete is taking
  sport: '', // Default sport
  questions: [], // Loaded questions for current quiz
  answers: [], // { questionId, selectedOption }
  currentQuestionIndex: 0, // Index of the question they're on
  scorePercent: null, // After submission
  passed: null, // true/false after submission
};

const quizSlice = createSlice({
  name: 'quiz',
  initialState,
  reducers: {
    setQuizInfo: (state, action) => {
      const { sport, level, questions } = action.payload;
      state.sport = sport;
      state.currentLevel = level;
      state.questions = questions;
      state.answers = [];
      state.currentQuestionIndex = 0;
      state.scorePercent = null;
      state.passed = null;
    },
    selectAnswer: (state, action) => {
      const { questionId, selectedOption } = action.payload;
      const existing = state.answers.find((a) => a.questionId === questionId);
      if (existing) {
        existing.selectedOption = selectedOption;
      } else {
        state.answers.push({ questionId, selectedOption });
      }
    },
    goToNextQuestion: (state) => {
      if (state.currentQuestionIndex < state.questions.length - 1) {
        state.currentQuestionIndex++;
      }
    },
    goToPreviousQuestion: (state) => {
      if (state.currentQuestionIndex > 0) {
        state.currentQuestionIndex--;
      }
    },
    goToSpecificQuestion: (state, action) => {
      const index = action.payload;
      if (index >= 0 && index < state.questions.length) {
        state.currentQuestionIndex = index;
      }
    },
    setQuizResults: (state, action) => {
      const { scorePercent, passed } = action.payload;
      state.scorePercent = scorePercent;
      state.passed = passed;
    },
    resetQuizState: (state) => {
      Object.assign(state, initialState);
    },
    setSelectedSport: (state, action) => {
      state.sport = action.payload;
    },
  }
});

export const {
  setQuizInfo,
  selectAnswer,
  goToNextQuestion,
  goToPreviousQuestion,
  goToSpecificQuestion,
  setQuizResults,
  resetQuizState,
  setSelectedSport
} = quizSlice.actions;

export default quizSlice.reducer;